import script from "./AdicionarMembrostarefa.vue?vue&type=script&setup=true&lang=js"
export * from "./AdicionarMembrostarefa.vue?vue&type=script&setup=true&lang=js"

import "./AdicionarMembrostarefa.vue?vue&type=style&index=0&id=083f9382&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-083f9382"]])

export default __exports__